import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import classNames from 'classnames';
import '../Menu/index.js';
import useSelectContext from './SelectContext.js';
import Check from '../../components/Checkbox/Check.js';
import styles from './Select2.js';
import MenuItem from '../Menu/MenuItem.js';

const SelectItem = /*#__PURE__*/React__default.forwardRef((_ref, ref) => {
  let {
    isDisabled,
    label,
    value,
    children,
    className,
    ...rest
  } = _ref;
  const {
    multiselect,
    selectedSelectItems,
    onItemSelect
  } = useSelectContext();
  const isSelected = selectedSelectItems.has(value);
  const sharedMenuItemProps = {
    ref,
    label,
    isDisabled
  };
  return /*#__PURE__*/React__default.createElement(MenuItem, _extends({}, rest, sharedMenuItemProps, {
    className: classNames(className, {
      [styles.selectedItem]: isSelected
    }),
    asChild: true,
    onSelect: () => onItemSelect === null || onItemSelect === void 0 ? void 0 : onItemSelect(value, !isSelected)
  }), /*#__PURE__*/React__default.createElement("div", {
    "aria-selected": isSelected,
    role: "treeitem"
  }, multiselect ? /*#__PURE__*/React__default.createElement(Check, {
    checked: isSelected,
    className: styles.checkbox,
    disabled: isDisabled
  }) : null, children !== null && children !== void 0 ? children : label));
});

export { SelectItem as default };
